"use client";
import { useAnalytics } from "@areahub/adapters/src/analytics/analytics.client";
import { getWebUrl } from "@areahub/config/src";
import { Box, Button, Heading, Stack, Text } from "@chakra-ui/react";
import { ButtonLink } from "@ui/components/button";
import { useRef } from "react";
import { Modal, Modal_T } from "../modal";

export interface ProPlanModal_T extends Modal_T {
  onClose: () => void;
  isOpen: boolean;
}

export const ProPlanModal = (props: ProPlanModal_T) => {
  const { isOpen, onClose } = props;
  const initialRef = useRef<HTMLInputElement>(null);
  const analytics = useAnalytics();
  return (
    <Modal
      initialFocusRef={initialRef as React.RefObject<any>}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Box>
        <Heading size="2xl" color="blue.500">
          Discover More With AreaHub Pro
        </Heading>
        <Text mt="30px" fontSize="md">
          Unlock more hazard categories along for only $24.99 per report. Search
          address-specific reports, explore detailed insights, and more with
          AreaHub Pro.
        </Text>
      </Box>
      <Stack
        w="full"
        flexDirection={{
          base: "column",
          md: "row",
        }}
        spacing={{
          base: "10px",
          md: "0",
        }}
        justifyContent={{
          base: "center",
          md: "space-evenly",
        }}
        alignItems={{
          base: "center",
        }}
      >
        <ButtonLink
          href={getWebUrl() + "/individuals/pricing"}
          colorScheme="blue"
          w="250px"
          h="45px"
          borderRadius="full"
          onClick={() =>
            analytics.track("user clicked see pricing plans", {
              ui: "ProPlanModal",
            })
          }
        >
          Check Out AreaHub Pro
        </ButtonLink>
      </Stack>
    </Modal>
  );
};
